import { CellContext } from '@tanstack/react-table';
import { Clock } from '@va/icons';
import { useLocale, useTranslate } from '@va/localization';
import { CellWithIcon } from '@va/ui/design-system';
import { addNumberSeparator, getFormattedDateAndTime } from '@va/util/helpers';
import moment from 'moment';

type DateCellV8Props<T> = { getValue: () => string } & Omit<
  CellContext<T & { itemsInGroup?: string }, unknown>,
  'getValue'
>;

export function DateCellV8<T>({ getValue, column, table }: DateCellV8Props<T>) {
  const value = getValue();
  const state = table.getState();
  const isGrouped = column.getIsGrouped();
  const translate = useTranslate();
  const { locale } = useLocale();
  const othersGrouped = !isGrouped && state.grouping.length > 0;
  if (othersGrouped) {
    const valueAsNumber = Number.parseInt(value);

    return (
      <CellWithIcon
        leftElement={<Clock strokeColor='#969696' />}
        topText={
          valueAsNumber === 1
            ? translate('eventTracking.table.value', {
                count: addNumberSeparator(valueAsNumber, locale),
              })
            : translate('eventTracking.table.values', {
                count: addNumberSeparator(valueAsNumber, locale),
              })
        }
      />
    );
  }

  const momentValue = moment(value).unix();

  return (
    <CellWithIcon
      leftElement={<Clock strokeColor='#969696' />}
      topText={getFormattedDateAndTime(momentValue, locale)}
    />
  );
}
